import { createEnum } from './enum.js'

export default createEnum('None', 'Right lower lid', 'Left lower lid', 'Both lower lids');
